<template>
  <div class="wrapper-mirror-category">
    <v-row>
      <v-col cols="12">
        <v-text-field
          label="Nome da categoria"
          v-model="form.categoryName"
          outlined
        />
        <v-text-field
          label="Nome curto da categoria"
          v-model="form.categoryShortName"
          outlined
        />
        <v-btn class="mr-4" @click="resetForm">Limpar</v-btn>
        <v-btn color="primary" @click="handleClickSave">
          {{ !isEditMode ? 'Cadastrar' : 'Editar' }}
        </v-btn>
      </v-col>
      <v-col cols="12">
        <div class="card-list-wrapper">
          <div class="card-list">
            <v-card
              class="mb-3"
              v-for="category in adminMirrorCategories"
              :key="category.name"
            >
              <div>
                <v-card-title>{{ category.name }}</v-card-title>
                <v-card-subtitle v-if="category.short_name">
                  {{ category.short_name }}
                </v-card-subtitle>
              </div>
              <v-card-actions>
                <v-btn icon title="editar" @click="handleClickEdit(category)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn
                  icon
                  title="remover"
                  @click="handleClickRemove(category.id)"
                >
                  <v-icon>remove</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'MirrorCategoryComponent',
  data: () => ({
    form: {
      id: '',
      categoryName: '',
      categoryShortName: '',
    },
    isEditMode: false,
    autoScrollOptions: {
      duration: 800,
      offset: 120,
      // container se refere ao elemento que contem o scroll
      container: 'html',
    },
  }),
  computed: {
    ...mapState({
      adminMirrorCategories: state => state.admin.adminMirrorCategories,
    }),
  },
  methods: {
    resetForm() {
      this.isEditMode = false;
      this.form.categoryName = '';
      this.form.categoryShortName = '';
      this.form.id = '';
    },
    scrollTop() {
      this.$vuetify.goTo(0, this.autoScrollOptions);
    },
    async handleClickSave() {
      if (this.isEditMode) {
        await this.$store.dispatch('admin/updateMirrorCategory', {
          name: this.form.categoryName,
          short_name: this.form.categoryShortName,
          id: this.form.id,
        });
        this.resetForm();
      } else {
        await this.$store.dispatch('admin/createMirrorCategory', {
          name: this.form.categoryName,
          short_name: this.form.categoryShortName,
        });
        this.resetForm();
      }
    },
    handleClickEdit(category) {
      this.isEditMode = true;
      this.form.categoryName = category.name;
      this.form.categoryShortName = category.short_name;
      this.form.id = category.id;

      this.scrollTop();
    },
    async handleClickRemove(id) {
      this.scrollTop();
      await this.$store.dispatch('admin/deleteMirrorCategory', id);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/theme.scss';

.wrapper-mirror-category {
  width: 700px;
  min-height: 50vh;
  overflow: hidden;
}

::v-deep {
  .v-input {
    &.v-input--is-focused {
      label {
        left: 0 !important;
      }
    }
    &.v-input--is-label-active {
      label {
        left: 0 !important;
      }
    }
  }

  .v-text-field {
    &.v-text-field--outlined {
      .v-label--active {
        transform: translateY(-18px) scale(0.75) !important;
        padding-left: 0 !important;
      }
    }
  }
}

.card-list-wrapper {
  width: 100%;

  .card-list {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 24px 16px;
    box-sizing: border-box;

    .v-card {
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      &__title {
        font-size: 1.2rem;
      }
      &__subtitle {
        color: #808080;
      }
    }

    @include for-size(phone-only) {
      display: block;
      width: 100%;
      padding: 16px;
      box-sizing: border-box;
    }
  }
}
</style>
